"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[88837,12495],{

/***/ 232771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useDiscoverySearchV2; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearchV2 = (discoveryService, params, configs, searchAlgoHeaderValue) => {
  const _a = configs || {}, { transform = (data2) => data2 } = _a, swrConfigs = __objRest(_a, ["transform"]);
  const { data, error } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(params && Object.keys(params).length ? [params, "discovery-search-v2"] : null, async (params2) => {
    const response = await discoveryService.search(params2, searchAlgoHeaderValue);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  return {
    result: data,
    error,
    loading: params && Object.keys(params).length ? !error && !data : false
  };
};




/***/ }),

/***/ 14643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useInfiniteDiscoverySearchV2; }
/* harmony export */ });
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382725);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useInfiniteDiscoverySearchV2 = (discoveryService, params, configs) => {
  var _b, _c;
  const _a = configs || {}, {
    transform = (data2) => data2
  } = _a, swrConfigs = __objRest(_a, [
    "transform"
  ]);
  const { data, size, setSize, isValidating, error } = (0,swr_infinite__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((page) => [
    __spreadProps(__spreadValues({}, params), { page: page + 1 }),
    "discovery-search-v2"
  ], async (payload) => {
    const response = await discoveryService.search(payload);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  const isEmpty = data && ((_b = data[0].products) == null ? void 0 : _b.length) === 0;
  const hasMore = (((_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.total) || 0) > size * ((params == null ? void 0 : params.pageSize) || 10);
  const loadmore = () => {
    setSize((page) => page + 1);
  };
  return {
    loading: isValidating,
    hasMore,
    data,
    loadmore,
    size,
    isEmpty: !!isEmpty,
    error
  };
};




/***/ }),

/***/ 512495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ FavouriteAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FavouriteAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5.75C16.6307 5.75 17.5345 6.15409 18.1899 6.80453C18.8431 7.45286 19.25 8.34674 19.25 9.33095C19.25 12.4832 14.6986 16.7712 12.6212 18.6318C12.444 18.7906 12.2221 18.8704 11.9999 18.8704C11.7775 18.8704 11.5553 18.7904 11.3778 18.6316C9.30052 16.7712 4.75 12.4832 4.75 9.33095C4.75 8.34674 5.15687 7.45286 5.81012 6.80453C6.46549 6.15409 7.36934 5.75 8.36379 5.75C9.63426 5.75 10.7192 6.417 11.3835 7.3758C11.6822 7.80686 11.8958 8.29678 12 8.8134C12.1041 8.29665 12.3178 7.80686 12.6165 7.3758C13.2808 6.417 14.365 5.75 15.6362 5.75Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 728873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ FavouriteFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FavouriteFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5C14.1086 5 12.8 5.79411 12 6.94863C11.2 5.79411 9.89053 5 8.36379 5C5.96379 5 4 6.94863 4 9.33095C4 12.6413 8.67537 17.2181 10.8775 19.1903C11.5183 19.7638 12.4817 19.7638 13.1217 19.1903C15.3238 17.2181 20 12.6413 20 9.33095C20 6.94863 18.0362 5 15.6362 5Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 288257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ WishlistButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(423942);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(106454);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(743126);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(728873);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(512495);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(775002);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(643015);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(684443);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(508285);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









const WishlistButton = (param)=>{
    let { sku , size ="26"  } = param;
    var ref;
    const { user , setUser , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
    const { showModal  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .useModal */ .d)();
    const { userService  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    const [, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .useLoading */ .r$)("wishListButton");
    const { isMobile , appName  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const toast = (0,_contexts__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .p)(isMobile);
    const isWishList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var ref, ref1;
        return !!(user === null || user === void 0 ? void 0 : (ref = user.metaData) === null || ref === void 0 ? void 0 : (ref1 = ref.wishList) === null || ref1 === void 0 ? void 0 : ref1.includes(sku));
    }, [
        sku,
        user === null || user === void 0 ? void 0 : (ref = user.metaData) === null || ref === void 0 ? void 0 : ref.wishList
    ]);
    const handleWhenNotLogin = ()=>{
        showModal({
            size: "m",
            title: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Th\xf4ng b\xe1o"),
            centeredTitle: true,
            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Đăng nhập"),
            cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Đ\xf3ng"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .k, {
                direction: "column",
                align: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Body */ .uT, {
                    marginTop: "s4",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Vui l\xf2ng đăng nhập t\xe0i khoản {{appName}} để th\xeam sản phẩm y\xeau th\xedch", {
                        appName: appName || ""
                    })
                })
            }),
            onOk: ()=>authService.login()
        });
    };
    const onClickWishList = async ()=>{
        try {
            var ref;
            if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                handleWhenNotLogin();
                return;
            }
            setLoading(true);
            const previousMetaData = (user === null || user === void 0 ? void 0 : user.metaData) || {};
            const previousWishlist = (previousMetaData === null || previousMetaData === void 0 ? void 0 : previousMetaData.wishList) || [];
            const listSku = [
                sku,
                ...previousWishlist
            ];
            const diskListSku = previousWishlist.filter((item)=>item !== sku);
            const profile = await userService.updateProfile({
                metaData: _objectSpreadProps(_objectSpread({}, previousMetaData), {
                    wishList: isWishList ? diskListSku : listSku
                })
            });
            const updatedProfile = _objectSpread({}, user, (0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__.cleanObject)(profile));
            setUser(updatedProfile);
            setLoading(false);
            if (updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref = updatedProfile.metaData) === null || ref === void 0 ? void 0 : ref.wishList.includes(sku)) {
                var ref1;
                (ref1 = toast.success) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                    title: "",
                    message: "",
                    duration: 3000,
                    closeable: false,
                    [isMobile ? "message" : "title"]: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                        level: 2,
                        children: [
                            (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)('Th\xeam th\xe0nh c\xf4ng v\xe0o mục "Sản phẩm y\xeau th\xedch". '),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/account/wish-list",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        color: _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .themeColor.link500 */ .E.link500
                                    },
                                    className: "text",
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Xem ngay")
                                })
                            })
                        ]
                    })
                });
            } else {
                var ref2;
                (ref2 = toast.success) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                    title: "",
                    message: "",
                    duration: 3000,
                    closeable: false,
                    [isMobile ? "message" : "title"]: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)('Xo\xe1 th\xe0nh c\xf4ng khỏi mục "Sản phẩm y\xeau th\xedch."')
                });
            }
        } catch (error) {
            var ref3;
            setLoading(false);
            (ref3 = toast.error) === null || ref3 === void 0 ? void 0 : ref3.call(toast, {
                title: "",
                message: "",
                duration: 3000,
                closeable: false,
                [isMobile ? "message" : "title"]: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("C\xf3 lỗi xảy ra")
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isWishList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__/* .FavouriteFilled */ .e, {
            onClick: (event)=>{
                event.preventDefault();
                onClickWishList();
            },
            size: size,
            color: "primary",
            style: {
                cursor: "pointer"
            }
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__/* .FavouriteAlternativeOutlined */ .w, {
            onClick: (event)=>{
                event.preventDefault();
                onClickWishList();
            },
            size: size,
            color: "primary",
            style: {
                cursor: "pointer"
            }
        })
    });
};


/***/ }),

/***/ 997441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eo": function() { return /* binding */ cookDiscoveryFilter; },
/* harmony export */   "Ot": function() { return /* binding */ transformBlock; },
/* harmony export */   "Zj": function() { return /* binding */ getBlockDomId; },
/* harmony export */   "jx": function() { return /* binding */ convertObjectDiscoveryToQueryStringSearch; },
/* harmony export */   "yA": function() { return /* binding */ findBlockByType; }
/* harmony export */ });
/* unused harmony exports fetchSingleDataBlockSSRFromDiscoveryV2, fetchDataBlockSSRFromDiscoveryV2 */
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(875663);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(428247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(775002);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








const listingAndDiscoveryKeysMap = {
    priceGte: "price_gte",
    priceLte: "price_lte"
};
const listingAndDiscoveryValuesMap = {
    ORDER_BY_DESCENDING: "DESC",
    ORDER_BY_ASCENDING: "ASC"
};
const convertObjectDiscoveryToQueryStringSearch = (params)=>{
    if (!params) return "/";
    const newParams = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)(_objectSpreadProps(_objectSpread({}, params), {
        router: "productListing"
    }));
    return "/search?" + Object.keys(newParams).map((key)=>{
        if (!newParams[key] || Array.isArray(newParams === null || newParams === void 0 ? void 0 : newParams[key]) && newParams[key].length === 0) {
            return;
        }
        return (listingAndDiscoveryKeysMap[key] || key) + "=" + (listingAndDiscoveryValuesMap[newParams[key]] || newParams[key]);
    }).filter((query)=>query).join("&");
};
const cookDiscoveryFilter = (filter)=>{
    if (!filter) return {};
    if (filter === null || filter === void 0 ? void 0 : filter.attributes.length) {
        filter.attributes.map((el)=>filter["attributes.".concat(el.code)] = el.optionIds.join());
        const { attributes: tbr  } = filter, newFilter = _objectWithoutProperties(filter, [
            "attributes"
        ]);
        return newFilter;
    }
    return filter;
};
const findBlockByType = (type, blocks)=>{
    return blocks && blocks.find((block)=>block.type === type);
};
const getUrl = (item)=>{
    var ref;
    const { url , redirectUrl , params  } = item || {};
    return redirectUrl ? redirectUrl : url || convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter), ((ref = item.params) === null || ref === void 0 ? void 0 : ref.sorting) || {}));
};
const getLinkHref = (url, paramsObject, title)=>{
    let href = null;
    if (url) {
        if (url.startsWith("/landing/")) {
            href = {
                pathname: "/landing/[id]",
                query: {
                    id: url.substring("/landing/".length)
                }
            };
        } else {
            href = url;
        }
    } else {
        // remove non-relevant flags from paramsObject
        // such as false param or empty array
        // we don't want them to appear on browser url
        /**
     *
     *  "sellingCodes": [],
        "priceLte": "0",
        "priceGte": "0",
        "brands": [],
        "flashSaleType": "",
        "masterCategories": [],
        "excludedSkus": [],
        "masterCategoryIds": [62],
      }
     */ const queryParams = {};
        for (const [key, value] of Object.entries(paramsObject)){
            if (value && (!Array.isArray(value) || value.length > 0) && (isNaN(value) || !!parseInt(value))) {
                queryParams[key] = value;
            }
        }
        href = {
            pathname: "/search",
            query: _objectSpreadProps(_objectSpread({}, queryParams), {
                pageTitle: title,
                router: "productListing"
            })
        };
    }
    return {
        href
    };
};
const transformBlockItemTypeSku = (block)=>{
    const { fetchParams , collectionSlug =""  } = block.content;
    block.cookedData = {
        queryString: convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter), fetchParams.sorting)),
        paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)({
            filter: collectionSlug ? undefined : cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter),
            sorting: collectionSlug ? {} : (fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.sorting) || {},
            slug: collectionSlug,
            blockId: block.id
        })
    };
    return block;
};
const transformBanner = (block)=>{
    const banners = block.content.items.map((item)=>{
        var ref, ref1;
        const paramsObject = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)(_objectSpreadProps(_objectSpread({}, cookDiscoveryFilter(item === null || item === void 0 ? void 0 : (ref = item.params) === null || ref === void 0 ? void 0 : ref.filter), ((ref1 = item.params) === null || ref1 === void 0 ? void 0 : ref1.sorting) || {}), {
            blockId: block.id,
            itemId: item.id
        }));
        return {
            id: item.id,
            targetPath: getUrl(item),
            image: item.imageUrl,
            campaignName: item.label,
            description: item.subLabel,
            paramsObject,
            url: item.url,
            thumbnail: item.thumbnail,
            link: getLinkHref(item.url || item.redirectUrl || "", paramsObject, item.label),
            imageSize: item.imageSize,
            as: item.url || item.redirectUrl || ""
        };
    });
    block.cookedData = banners || [];
    return block;
};
const transformBlockMixBanner = (block)=>{
    var ref, ref1;
    const firstItem = block === null || block === void 0 ? void 0 : (ref = block.content) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0];
    const trackingRegionName = "categoriesBlockBrand";
    block.cookedData = {
        header: {
            title: block.label,
            link: {
                href: getUrl(firstItem)
            }
        },
        banner: {
            src: firstItem.imageUrl,
            alt: firstItem.label || firstItem.subLabel,
            tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: trackingRegionName,
                contentName: firstItem.label,
                target: getUrl(firstItem)
            }),
            link: {
                href: getUrl(firstItem)
            }
        },
        contentItems: block.content.items.slice(1, 5).map((category)=>({
                name: category.label,
                description: category.subLabel,
                image: {
                    src: category.imageUrl,
                    alt: category.label || category.subLabel
                },
                link: {
                    href: getUrl(category)
                }
            })),
        bottomImages: block.content.items.slice(5, 11).map((brand, index)=>({
                src: brand.imageUrl,
                alt: brand.label || brand.subLabel,
                tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: trackingRegionName,
                    contentName: brand.label,
                    index,
                    target: getUrl(brand)
                }),
                link: {
                    href: getUrl(brand)
                }
            }))
    };
    return block;
};
const transformBlockHotDeal = (block)=>{
    block.cookedData = block.content.items.map((el)=>{
        const { collectionSlug , params , id  } = el;
        return _objectSpreadProps(_objectSpread({}, el), {
            name: el.label,
            url: el.redirectUrl || el.url,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
    });
    return block;
};
const transformBlockListingTab = (block)=>{
    const categoryList = [];
    block.content.items.forEach((item)=>{
        const { collectionSlug , params , id  } = item;
        const obj = _objectSpreadProps(_objectSpread({}, item), {
            id: item.id,
            name: item.label,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
        categoryList.push(obj);
    });
    block.cookedData = categoryList;
    return block;
};
const transformBlock = (block)=>{
    if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.SKU */ .Nc.SKU) return transformBlockItemTypeSku(block);
    else if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.BANNER */ .Nc.BANNER || [
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_HIGHLIGHTED_BANNER */ .kH.HORIZONTAL_HIGHLIGHTED_BANNER,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_CATEGORY */ .kH.RECOMMENDED_CATEGORY,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_BRANDS */ .kH.RECOMMENDED_BRANDS,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.PROMOTE_CATEGORY_MENU */ .kH.PROMOTE_CATEGORY_MENU,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_2_BANNER_MOBILE */ .kH.HORIZONTAL_2_BANNER_MOBILE, 
    ].includes(block.type)) return transformBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER) return transformBlockMixBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_TAB_MOBILE */ .kH.COUNT_DOWN_PROMO_TAB_MOBILE) return transformBlockHotDeal(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.LISTING_TAB */ .kH.LISTING_TAB) return transformBlockListingTab(block);
    else return block;
};
// fetch data for default block page (brand & seller page)
const fetchSingleDataBlockSSRFromDiscoveryV2 = async function(context, block) {
    let includeFilter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, optionalSortingParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const { req , query  } = context;
    const { tenantEnv , location  } = req;
    const { discoveryServiceV2 , discoveryHelper  } = new ServiceContainer(tenantEnv);
    const { sort , order  } = optionalSortingParams;
    try {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        const [{ products  }, resultFilter] = await Promise.all([
            discoveryServiceV2.search({
                page: parseInt((query.page || "1").toString()),
                pageSize: ITEM_PER_PAGE_IN_LISTING_PAGE,
                slug: block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : (ref1 = ref.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.filter, query)),
                sorting: convertToPayloadSorting(sort, order),
                location
            }),
            includeFilter ? await discoveryServiceV2.search({
                pageSize: 1,
                slug: block === null || block === void 0 ? void 0 : (ref4 = block.cookedData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : ref5.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref6 = block.cookedData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.paramsObject) === null || ref7 === void 0 ? void 0 : ref7.filter)),
                returnFilterable: [
                    "FILTER_TYPE_ATTRIBUTE",
                    "FILTER_TYPE_BRAND",
                    "FILTER_TYPE_PRICE",
                    "FILTER_TYPE_CLEARANCE", 
                ],
                location
            }) : {}, 
        ]);
        return {
            ssrProducts: (products || []).map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product)),
            filters: resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter,
            filterPrice: {
                max: Number((ref8 = resultFilter.filter) === null || ref8 === void 0 ? void 0 : ref8.priceLte),
                min: Number((ref9 = resultFilter.filter) === null || ref9 === void 0 ? void 0 : ref9.priceGte)
            }
        };
    } catch (error) {
        logger.error(error);
        return {};
    }
};
const fetchDataBlockSSRFromDiscoveryV2 = async (context, blocks)=>{
    const { discoveryHelper , discoveryServiceV2  } = new ServiceContainer(context.req.tenantEnv);
    const simpleProductBlocks = blocks.filter((b)=>[
            BlockType.FLASH_SALE,
            BlockType.PROMOTE_SELLER,
            BlockType.BEST_SELLING_PRODUCT,
            BlockType.LIST_SKU_MOBILE,
            BlockType.MAIN_SKU_LIST,
            BlockType.COUNT_DOWN_PROMO_SKU,
            BlockType.HORIZONTAL_SKU_LIST, 
        ].includes(b.type) && b.itemType === BlockItemType.SKU);
    const partialRenderedBlocks = blocks.filter((b)=>[
            BlockType.COUNT_DOWN_PROMO_TAB_MOBILE,
            BlockType.COUNT_DOWN_PROMO_BIG_SKU,
            BlockType.LISTING_TAB, 
        ].includes(b.type));
    const mapProducts = await Promise.all([
        ...simpleProductBlocks.map(async (block)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            const products = await discoveryServiceV2.search({
                slug: block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : (ref1 = ref.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.filter, context.query)),
                sorting: convertToPayloadSorting(context.query.sort || (block === null || block === void 0 ? void 0 : (ref4 = block.cookedData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sorting) === null || ref6 === void 0 ? void 0 : ref6.sort), context.query.order || (block === null || block === void 0 ? void 0 : (ref7 = block.cookedData) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.paramsObject) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sorting) === null || ref9 === void 0 ? void 0 : ref9.order)),
                pageSize: context.req.tenantEnv.isMobile ? ITEM_PER_PAGE_IN_LISTING_PAGE : SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE
            }).then((res)=>{
                return ((res === null || res === void 0 ? void 0 : res.products) || []).map((p)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(p, {
                        hideHighlightAttribute: true
                    }));
            }).catch((error)=>{
                logger.error("[discovery-v2]", error);
                return [];
            });
            return {
                [block.id]: products
            };
        }),
        ...partialRenderedBlocks.map(async (block)=>{
            var ref;
            // paramObject contant: blockId, itemId and other filter of discovery
            const firstItem = block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref[0];
            const blockId = block === null || block === void 0 ? void 0 : block.id;
            const itemId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
            const paramsObject = firstItem === null || firstItem === void 0 ? void 0 : firstItem.paramsObject;
            if (!paramsObject || !blockId || !itemId) {
                return {};
            }
            try {
                const result = await discoveryServiceV2.search(_objectSpreadProps(_objectSpread({}, paramsObject), {
                    pageSize: 20,
                    location: context.req.location
                }));
                const products = ((result === null || result === void 0 ? void 0 : result.products) || []).map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, {
                        hideHighlightAttribute: true
                    }));
                return {
                    ["".concat(blockId, "_").concat(itemId)]: products
                };
            } catch (error) {
                logger.error(error);
                return {};
            }
        }), 
    ]);
    return mapProducts.filter(Boolean).reduce((acc, curr)=>Object.assign(acc || {}, curr), {});
};
const getBlockDomId = (block)=>block.label ? (0,_teko_slug__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(block.label) : "".concat(block.name, "-").concat(block.id);


/***/ }),

/***/ 88837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uD": function() { return /* binding */ useDiscovery_useDiscoveryProduct; },
  "b9": function() { return /* binding */ useDiscovery_useDiscoverySearch; },
  "nC": function() { return /* binding */ useInfiniteSearch; },
  "yz": function() { return /* binding */ useDiscovery_usePersonalizeBlocks; },
  "lR": function() { return /* binding */ useRecommendationComboDetail; },
  "jG": function() { return /* binding */ useRecommendationCombosData; },
  "mF": function() { return /* binding */ useRecommendationProductsData; },
  "Rx": function() { return /* binding */ useSearch; },
  "TA": function() { return /* binding */ useDiscovery_useSkus; }
});

// UNUSED EXPORTS: useInfiniteDiscoverySearch

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(423942);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/infinite/dist/index.esm.js
var dist_index_esm = __webpack_require__(382725);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(77829);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/types.es.js
var types_es = __webpack_require__(875663);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/hooks.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearch = (discoveryService, params, location, options) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const _b = options || {}, {
    transformProduct = (data2) => data2
  } = _b, swrConfigs = __objRest(_b, [
    "transformProduct"
  ]);
  const keyAPI = (0,helpers_es/* getKeyAPI */.jG)(params, discoveryService.getBaseUrl());
  const normalizedParams = (0,helpers_es/* normalizePageBuilderToDiscoveryParams */.nS)(searchParams);
  const { data, error } = (0,index_esm/* default */.ZP)(keyAPI, async () => {
    const { sellerIds } = params;
    let newSellerIds = sellerIds;
    if (Array.isArray(sellerIds) && typeof sellerIds[0] === "number") {
      newSellerIds = sellerIds.map((id) => id.toString());
    }
    const response = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      sellerIds: newSellerIds,
      location
    }));
    return __spreadProps(__spreadValues({}, response), {
      result: __spreadProps(__spreadValues({}, response.result), {
        products: response.result.products.map(transformProduct)
      })
    });
  }, __spreadProps(__spreadValues({}, swrConfigs), {
    revalidateOnFocus: false
  }));
  const result = data == null ? void 0 : data.result;
  return {
    result: {
      products: (result == null ? void 0 : result.products) || [],
      filters: (result == null ? void 0 : result.filter) || {},
      pagination: (data == null ? void 0 : data.pagination) || {},
      cookedFilters: (0,helpers_es/* cookFilter */.BR)(result == null ? void 0 : result.filter, normalizedParams, result == null ? void 0 : result.masterCategories)
    },
    isLoading: !params ? false : !error && !data,
    isError: error
  };
};
const useInfiniteDiscoverySearch = (discoveryService, params, options) => {
  var _c;
  const _a = options || {}, {
    transformProduct = (data2) => data2
  } = _a, swrOptions = __objRest(_a, [
    "transformProduct"
  ]);
  const getKey = (pageIndex) => {
    const _a2 = params, rest2 = __objRest(_a2, ["page"]);
    return [rest2, pageIndex];
  };
  const convertSearchResponse = (response) => {
    var _a2, _b2;
    return {
      products: (((_a2 = response.result) == null ? void 0 : _a2.products) || []).map(transformProduct),
      suggestedKeyword: (_b2 = response.result) == null ? void 0 : _b2.suggestedKeyword,
      pagination: response.pagination
    };
  };
  const _b = useSWRInfinite(getKey, async (_params, index) => {
    const response = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      page: parseInt(params.page || "1") + index
    }));
    return convertSearchResponse(response);
  }, swrOptions), { data, isValidating, size, setSize } = _b, rest = __objRest(_b, ["data", "isValidating", "size", "setSize"]);
  const isEmpty = data && data[0].products.length === 0;
  const hasMore = !(isEmpty || data && data[data.length - 1] && data[data.length - 1].products.length < (params.itemsPerPage || 10));
  const products = data ? data.reduce((acc, curr) => {
    return [...acc, ...curr.products];
  }, []) : [];
  const cookedData = data == null ? void 0 : data[0];
  const pagination = (data == null ? void 0 : data.length) ? (_c = data[data.length - 1]) == null ? void 0 : _c.pagination : void 0;
  return __spreadValues({
    isEmpty: !!isEmpty,
    isLoading: isValidating,
    hasMore,
    size,
    setSize,
    products,
    suggestedKeyword: cookedData == null ? void 0 : cookedData.suggestedKeyword,
    isValidating,
    pagination
  }, rest);
};
const useDiscoveryProduct = (discoveryService, sku, location) => {
  const { data, error } = useSWR(!!sku ? [`${discoveryService.getBaseUrl}/product`, sku, location] : null, async (_, sku2, location2) => {
    return await discoveryService.getProduct({
      sku: sku2,
      location: location2
    });
  });
  return {
    result: {
      product: data || null
    },
    isLoading: !error && !data,
    isError: !!error
  };
};
const usePersonalizeBlocks = (discoveryService, blockParams, transformBlock) => {
  var _a, _b;
  const { pageTypeEnum, category, seller, brand, sellerCategory } = blockParams;
  const params = (0,index_es.cleanObject)(__spreadValues({}, blockParams));
  const conditionFetching = pageTypeEnum === types_es/* PageTypeEnum.HOME */.DZ.HOME || types_es/* PageTypeEnum.NOTIFICATION */.DZ.NOTIFICATION || pageTypeEnum === types_es/* PageTypeEnum.CATEGORY */.DZ.CATEGORY && (category || sellerCategory) || pageTypeEnum === types_es/* PageTypeEnum.BRAND */.DZ.BRAND && brand || pageTypeEnum === types_es/* PageTypeEnum.SELLER */.DZ.SELLER && seller;
  const { data, error } = (0,index_esm/* default */.ZP)(conditionFetching ? [`${discoveryService.getBaseUrl}/blocks`, JSON.stringify(params)] : null, async (_, paramsJson) => {
    return await discoveryService.getBlock(JSON.parse(paramsJson));
  }, {
    revalidateOnFocus: false
  });
  return {
    result: (((_a = data == null ? void 0 : data.result) == null ? void 0 : _a.blocks) || []).map(transformBlock),
    seoInfo: ((_b = data == null ? void 0 : data.result) == null ? void 0 : _b.seoInfo) || {},
    isLoading: !error && !data,
    isError: error
  };
};
const useSkus = (discoveryService, skus, location) => {
  const { data, error } = (0,index_esm/* default */.ZP)(skus ? [`${discoveryService.getBaseUrl}/products`, skus.join(","), location] : null, async (_, skus2, location2) => {
    return await discoveryService.getProductDetailBySkus({
      skus: skus2,
      location: location2
    });
  });
  return {
    result: {
      products: data || []
    },
    isLoading: !skus ? false : !error && !data,
    isError: error
  };
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/useDiscoverySearch.es.js
var useDiscoverySearch_es = __webpack_require__(232771);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/useInfiniteDiscoverySearch.es.js
var useInfiniteDiscoverySearch_es = __webpack_require__(14643);
// EXTERNAL MODULE: ./components/WishlistButton.tsx
var WishlistButton = __webpack_require__(288257);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./helpers/block.ts
var block = __webpack_require__(997441);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 2 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(725530);
;// CONCATENATED MODULE: ./hooks/useDiscovery.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













const checkAlcoholicProduct = (product)=>{
    var ref, ref1;
    if (!product) return product;
    let sellerCatCodes = [];
    const categories = (product === null || product === void 0 ? void 0 : (ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.categories) || [];
    const masterCategories = (product === null || product === void 0 ? void 0 : (ref1 = product.productInfo) === null || ref1 === void 0 ? void 0 : ref1.masterCategories) || [];
    sellerCatCodes = categories.concat(masterCategories);
    return _objectSpreadProps(_objectSpread({}, product), {
        isAlcoholicCategory: sellerCatCodes.some((item)=>item.isAdult)
    });
};
const useDiscovery_useDiscoverySearch = (params, options)=>{
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const resultRef = (0,react.useRef)((options === null || options === void 0 ? void 0 : options.fallbackData) ? options === null || options === void 0 ? void 0 : options.fallbackData : {
        products: [],
        pagination: {
            totalItems: 0,
            totalPages: 1
        },
        filters: {}
    });
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService , discoveryPos365Service  } = (0,ServiceContext/* useServices */.Su)();
    const _ref = useDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, location, _objectSpreadProps(_objectSpread({}, options), {
        fallbackData: null,
        transformProduct: options === null || options === void 0 ? void 0 : options.transformProduct
    })), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const { isLoading  } = rest;
    const persistentData = isLoading ? resultRef.current : result;
    resultRef.current = persistentData;
    return _objectSpread({
        result: _objectSpreadProps(_objectSpread({}, persistentData), {
            products: persistentData === null || persistentData === void 0 ? void 0 : persistentData.products
        })
    }, rest);
};
const useDiscovery_useInfiniteDiscoverySearch = (params, options)=>{
    const { discoveryService , discoveryPos365Service  } = useServices();
    const _ref = useEcomInfiniteDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, _objectSpreadProps(_objectSpread({}, options), {
        transformProduct: options === null || options === void 0 ? void 0 : options.transformProduct
    })), { products  } = _ref, rest = _objectWithoutProperties(_ref, [
        "products"
    ]);
    return _objectSpread({
        products
    }, rest);
};
const useDiscovery_useDiscoveryProduct = (sku, productId, options)=>{
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const productRef = (0,react.useRef)((options === null || options === void 0 ? void 0 : options.fallbackData) ? options === null || options === void 0 ? void 0 : options.fallbackData : null);
    const { data , mutate , error , isValidating: isLoading ,  } = (0,index_esm/* default */.ZP)(!!sku ? [
        sku,
        location,
        productId
    ] : null, async (sku, location, productId)=>{
        const params = {
            productId,
            sku,
            location
        };
        return discoveryService.getProduct(params);
    }, _objectSpreadProps(_objectSpread({}, options), {
        fallbackData: null,
        revalidateOnFocus: false
    }));
    const product = isLoading || !data ? productRef.current : data;
    productRef.current = product;
    return {
        result: {
            product: product && checkAlcoholicProduct(product)
        },
        isLoading,
        isError: !!error,
        mutate
    };
};
const useDiscovery_usePersonalizeBlocks = (blockParams)=>{
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return usePersonalizeBlocks(discoveryService, blockParams, block/* transformBlock */.Ot);
};
const useDiscovery_useSkus = (skus)=>{
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return useSkus(discoveryService, skus, location);
};
const useRecommendationProductsData = (sku)=>{
    var ref;
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku ? [
        "".concat(discoveryService.getBaseUrl, "/products_recommendation"),
        sku
    ] : null, async (_, sku)=>{
        return await discoveryService.getRecommendationProducts(sku);
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            productSets: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.productSets) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationCombosData = (sku)=>{
    var ref;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku ? [
        "".concat(discoveryService.getBaseUrl, "/products_combo"),
        sku,
        location
    ] : null, async (_, sku, location)=>{
        return await discoveryService.getRecommendationCombos(sku, {
            location
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            combos: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.combos) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationComboDetail = function(payloadCombo) {
    let call = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const skus = ((payloadCombo === null || payloadCombo === void 0 ? void 0 : payloadCombo.comboLineItems) || []).map((el)=>el.sku);
    const { data , error  } = (0,index_esm/* default */.ZP)(payloadCombo && call ? [
        "".concat(discoveryService.getBaseUrl, "/detail-combo"),
        JSON.stringify(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            location
        })), 
    ] : null, (_)=>{
        return discoveryService.getDetailComboRecommendation(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            location
        })).then((res)=>{
            var ref;
            return res === null || res === void 0 ? void 0 : (ref = res.result) === null || ref === void 0 ? void 0 : ref.combo;
        });
    }, {
        revalidateOnFocus: false
    });
    const reorderProductInCombo = ()=>{
        if (!data) return null;
        const { products  } = data;
        const newProducts = skus.map((el)=>{
            const product = products.find((p)=>p.product.productInfo.sku === el);
            return product;
        });
        return _objectSpreadProps(_objectSpread({}, data), {
            products: newProducts
        });
    };
    return {
        result: {
            combo: reorderProductInCombo()
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useSearch = (params, fallbackData, options, searchAlgoHeaderValue, showCtaButton)=>{
    var ref;
    const { contactLink , isAllowATCFromListing , isDisplayUom , showNewProductGift ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T6)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const router = (0,next_router.useRouter)();
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing || showCtaButton,
        cartV2,
        frames,
        showNewProductGift,
        hideHighlightAttribute: (0,common/* isHomepage */.GH)(router.asPath),
        // Enable tracking open in new tab (middle click or ctrl/cmd + left click)
        enableTrackOpenInNewTab: router.asPath.includes("/search") || router.asPath.includes("/c/")
    };
    var _quantity;
    const totalCartItems = (0,react.useMemo)(()=>cartV2.flattenItems.reduce((acc, curr)=>acc + ((_quantity = curr.quantity) !== null && _quantity !== void 0 ? _quantity : 0), 0), [
        cartV2.flattenItems
    ]);
    // eslint-disable-next-line no-undef
    const transformProduct = (0,react.useCallback)((product)=>{
        return transformProductWhenUserUnder18((0,discovery/* createHandleEventAndCtaButton */.D3)(product, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
            wishlistButton: {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistButton/* WishlistButton */.s, {
                    sku: product.sku
                })
            }
        })));
    }, [
        totalCartItems,
        authLoading
    ]);
    const defaultFallbackData = {
        products: [],
        pagination: {
            totalItems: 0,
            totalPages: 1
        },
        filters: {}
    };
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const resultRef = (0,react.useRef)(fallbackData ? fallbackData : defaultFallbackData);
    const { error , loading , result  } = (0,useDiscoverySearch_es/* useDiscoverySearchV2 */.t)(discoveryServiceV2, _objectSpread({}, params), _objectSpreadProps(_objectSpread({
        transform: (data)=>{
            var ref;
            return {
                products: (data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig)))) || [],
                filters: data === null || data === void 0 ? void 0 : data.filter,
                pagination: {
                    totalItems: data.total,
                    totalPages: Math.ceil(data.total / search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9)
                },
                seoInfo: data.seoInfo,
                cookedFilters: {}
            };
        }
    }, options), {
        // disable most of revalidating mechanisms
        revalidateOnFocus: false,
        shouldRetryOnError: false
    }), typeof searchAlgoHeaderValue === "string" ? searchAlgoHeaderValue.replace(search/* SEARCH_ALGO.REPLACE_PATTERN */.XH.REPLACE_PATTERN, "") : searchAlgoHeaderValue);
    const persistentData = loading ? resultRef.current : result || defaultFallbackData;
    resultRef.current = persistentData;
    return {
        isError: !!error,
        isLoading: loading || false,
        result: _objectSpreadProps(_objectSpread({}, persistentData), {
            products: persistentData === null || persistentData === void 0 ? void 0 : (ref = persistentData.products) === null || ref === void 0 ? void 0 : ref.map(transformProduct)
        }),
        transformProduct
    };
};
const useInfiniteSearch = (params, fallbackData)=>{
    const { isDisplayUom , contactLink , isAllowATCFromListing  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T6)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing,
        cartV2,
        frames
    };
    var _quantity;
    const totalCartItems = (0,react.useMemo)(()=>cartV2.flattenItems.reduce((acc, curr)=>acc + ((_quantity = curr.quantity) !== null && _quantity !== void 0 ? _quantity : 0), 0), [
        cartV2.flattenItems
    ]);
    // eslint-disable-next-line no-undef
    const transformProduct = (0,react.useCallback)((product)=>{
        return transformProductWhenUserUnder18((0,discovery/* createHandleEventAndCtaButton */.D3)(product, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
            wishlistButton: {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistButton/* WishlistButton */.s, {
                    sku: product.sku
                })
            }
        })));
    }, [
        totalCartItems,
        authLoading
    ]);
    const _ref = (0,useInfiniteDiscoverySearch_es/* useInfiniteDiscoverySearchV2 */.x)(discoveryServiceV2, _objectSpread({}, params), {
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig))),
                total: data.total
            };
        },
        fallbackData: [
            {
                products: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.products,
                total: 0
            }, 
        ]
    }), { data , loadmore , loading: isLoading  } = _ref, rest = _objectWithoutProperties(_ref, [
        "data",
        "loadmore",
        "loading"
    ]);
    const products = (data === null || data === void 0 ? void 0 : data.map((el)=>el.products || []).flat()) || [];
    return _objectSpread({
        products: products === null || products === void 0 ? void 0 : products.map(transformProduct),
        onNextPage: loadmore,
        isLoading
    }, rest);
};


/***/ }),

/***/ 725530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useHandlerUnderEighteenYearOld; }
});

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(423942);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
;// CONCATENATED MODULE: ./assets/18+.svg
/* harmony default export */ var _18_ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjE3IiBoZWlnaHQ9IjE5MCIgdmlld0JveD0iMCAwIDIxNyAxOTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMTciIGhlaWdodD0iMTkwIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjYuNDA3OCAxNDMuMjY1TDI2LjQwNjggMTQzLjI2N0MyMC4zNjUxIDE1My4xMzQgMjcuNzgwMyAxNjUuODYzIDQwLjM0MDEgMTY1Ljg2M0gxNzYuNTdDMTg5LjEzIDE2NS44NjMgMTk2LjU0NSAxNTMuMTM0IDE5MC41MDQgMTQzLjI2N0wxOTAuNTAyIDE0My4yNjRMMTIyLjQzNCAzMS43MjgzQzEyMi40MzMgMzEuNzI3NyAxMjIuNDMzIDMxLjcyNzEgMTIyLjQzMyAzMS43MjY2QzExNi4yNTIgMjEuNjM1NCAxMDAuNzQ5IDIxLjYzNTQgOTQuNTY4MiAzMS43MjY3TDI2LjQwNzggMTQzLjI2NVpNMjYuNDA3OCAxNDMuMjY1TDk0LjU2NzIgMzEuNzI4M0wyNi40MDc4IDE0My4yNjVaIiBmaWxsPSIjRkZFN0M4IiBzdHJva2U9IiNGRkIwNDgiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNNzkuNzUzIDgwLjQyNzNIODYuOTg0OVYxMTQuNjE1SDc4Ljc1ODZWODguNjMyNEw3Mi4zNDAzIDkwLjI1NjNMNzAuMzUxNiA4My41ODk3TDc5Ljg0MzQgODAuMzQxOEw3OS43NTMgODAuNDI3M1oiIGZpbGw9IiM5NjVFMUEiLz4KPHBhdGggZD0iTTExNS4yOCAxMTIuNTY0QzExMi45MjkgMTE0LjQ0NCAxMDkuNjc1IDExNS4zODUgMTA1LjQyNiAxMTUuMzg1QzEwMS4xNzggMTE1LjM4NSA5OC4wMTM2IDExNC40NDQgOTUuNTcyOCAxMTIuNTY0QzkzLjIyMjUgMTEwLjc2OSA5Mi4xMzc3IDEwOC4yMDUgOTIuMTM3NyAxMDUuMDQzQzkyLjEzNzcgMTAxLjQ1MyA5My42NzQ1IDk4LjcxOCA5Ni44Mzg0IDk2LjgzNzZDOTQuNDg4MSA5NS4xMjgyIDkzLjQwMzMgOTIuODIwNiA5My40MDMzIDg5LjkxNDZDOTMuNDAzMyA4Ni43NTIyIDk0LjU3ODUgODQuMjczNSA5Ni44Mzg0IDgyLjQ3ODdDOTkuMDk4NCA4MC42ODM4IDEwMS45OTEgNzkuODI5MSAxMDUuNDI2IDc5LjgyOTFDMTA4Ljg2MSA3OS44MjkxIDExMS44NDUgODAuNjgzOCAxMTQuMDE0IDgyLjQ3ODdDMTE2LjI3NCA4NC4yNzM1IDExNy40NDkgODYuNzUyMiAxMTcuNDQ5IDg5LjkxNDZDMTE3LjQ0OSA5Mi44MjA2IDExNi4yNzQgOTUuMTI4MiAxMTQuMDE0IDk2LjgzNzZDMTE3LjE3OCA5OC43MTggMTE4LjcxNSAxMDEuNDUzIDExOC43MTUgMTA1LjA0M0MxMTguNzE1IDEwOC4yMDUgMTE3LjU0IDExMC43NjkgMTE1LjI4IDExMi41NjRaTTEwOS4wNDIgMTA2LjkyM0MxMDkuOTQ2IDEwNi4xNTQgMTEwLjM5OCAxMDUuMTI4IDExMC4zOTggMTAzLjkzMkMxMTAuMzk4IDEwMi43MzUgMTA5Ljk0NiAxMDEuNzA5IDEwOS4wNDIgMTAwLjk0QzEwOC4wNDggMTAwLjE3MSAxMDYuODczIDk5LjgyOTEgMTA1LjQyNiA5OS44MjkxQzEwMy45OCA5OS44MjkxIDEwMi44MDUgMTAwLjI1NiAxMDEuODEgMTAwLjk0QzEwMC45MDYgMTAxLjcwOSAxMDAuNDU0IDEwMi42NSAxMDAuNDU0IDEwMy45MzJDMTAwLjQ1NCAxMDUuMjE0IDEwMC45MDYgMTA2LjIzOSAxMDEuODEgMTA2LjkyM0MxMDIuNzE0IDEwNy42OTIgMTAzLjg4OSAxMDguMDM0IDEwNS40MjYgMTA4LjAzNEMxMDYuOTYzIDEwOC4wMzQgMTA4LjEzOCAxMDcuNjkyIDEwOS4wNDIgMTA2LjkyM1pNMTAyLjcxNCA4OC4wMzQyQzEwMi4wODIgODguNjMyNSAxMDEuNzIgODkuNDg3MiAxMDEuNzIgOTAuNDI3NEMxMDEuNzIgOTEuMzY3NiAxMDIuMDgyIDkyLjIyMjMgMTAyLjcxNCA5Mi44MjA2QzEwMy4zNDcgOTMuNDE4OSAxMDQuMzQxIDkzLjc2MDcgMTA1LjQyNiA5My43NjA3QzEwNi41MTEgOTMuNzYwNyAxMDcuNTA1IDkzLjUwNDMgMTA4LjEzOCA5Mi44MjA2QzEwOC43NzEgOTIuMjIyMyAxMDkuMTMzIDkxLjM2NzYgMTA5LjEzMyA5MC40Mjc0QzEwOS4xMzMgODkuNDg3MiAxMDguNzcxIDg4LjYzMjUgMTA4LjEzOCA4OC4wMzQyQzEwNy41MDUgODcuNDM1OSAxMDYuNTExIDg3LjA5NDEgMTA1LjQyNiA4Ny4wOTQxQzEwNC4zNDEgODcuMDk0MSAxMDMuMzQ3IDg3LjM1MDUgMTAyLjcxNCA4OC4wMzQyWiIgZmlsbD0iIzk2NUUxQSIvPgo8cGF0aCBkPSJNMTQ2LjY0OCA5NC4xMDI1VjEwMC45NEgxMzguNDIyVjEwOC43MThIMTMxLjE5VjEwMC45NEgxMjIuOTY0Vjk0LjEwMjVIMTMxLjE5Vjg2LjMyNDdIMTM4LjQyMlY5NC4xMDI1SDE0Ni42NDhaIiBmaWxsPSIjOTY1RTFBIi8+CjxwYXRoIGQ9Ik03OS4yMTA1IDEzNy43NzhINDIuNTA4OFYxMzkuNzQ0SDc5LjIxMDVWMTM3Ljc3OFoiIGZpbGw9IiM5NjVFMUEiLz4KPHBhdGggZD0iTTE3NC40OTEgMTM3Ljc3OEgxMzcuNzg5VjEzOS43NDRIMTc0LjQ5MVYxMzcuNzc4WiIgZmlsbD0iIzk2NUUxQSIvPgo8cGF0aCBkPSJNODUuMjY3NSAxNDQuMzU5QzgzLjU0OTkgMTQyLjczNSA4Mi43MzYzIDE0MC43NjkgODIuNzM2MyAxMzguNDYxQzgyLjczNjMgMTM2LjE1NCA4My41NDk5IDEzNC4xMDMgODUuMjY3NSAxMzIuNTY0Qzg2Ljk4NSAxMzAuOTQgODkuMDY0MiAxMzAuMTcxIDkxLjUwNSAxMzAuMTcxQzkzLjk0NTcgMTMwLjE3MSA5Ni4wMjQ5IDEzMC45NCA5Ny43NDI1IDEzMi41NjRDOTkuNDYgMTM0LjE4OCAxMDAuMjc0IDEzNi4xNTQgMTAwLjI3NCAxMzguNDYxQzEwMC4yNzQgMTQwLjc2OSA5OS40NiAxNDIuODIgOTcuNzQyNSAxNDQuMzU5Qzk2LjAyNDkgMTQ1Ljg5NyA5My45NDU3IDE0Ni43NTIgOTEuNTA1IDE0Ni43NTJDODkuMDY0MiAxNDYuNzUyIDg2Ljk4NSAxNDUuOTgzIDg1LjI2NzUgMTQ0LjM1OVpNOTUuMDMwNSAxNDEuODhDOTUuOTM0NSAxNDEuMDI2IDk2LjQ3NjkgMTM5LjgyOSA5Ni40NzY5IDEzOC40NjFDOTYuNDc2OSAxMzcuMDk0IDk2LjAyNDkgMTM1Ljg5NyA5NS4wMzA1IDEzNS4wNDNDOTQuMTI2NSAxMzQuMTg4IDkyLjk1MTMgMTMzLjY3NSA5MS41MDUgMTMzLjY3NUM5MC4wNTg2IDEzMy42NzUgODguODgzNCAxMzQuMTAzIDg3Ljk3OTQgMTM1LjA0M0M4Ny4wNzU0IDEzNS44OTcgODYuNTMzMSAxMzcuMDk0IDg2LjUzMzEgMTM4LjQ2MUM4Ni41MzMxIDEzOS44MjkgODYuOTg1MSAxNDEuMDI2IDg3Ljk3OTQgMTQxLjg4Qzg4Ljg4MzQgMTQyLjczNSA5MC4wNTg2IDE0My4yNDggOTEuNTA1IDE0My4yNDhDOTIuOTUxMyAxNDMuMjQ4IDk0LjAzNjEgMTQyLjgyIDk1LjAzMDUgMTQxLjg4WiIgZmlsbD0iIzk2NUUxQSIvPgo8cGF0aCBkPSJNMTE0LjAxNCAxMzkuNDAyVjE0Ni40MTFIMTEwLjM5OFYxMzkuOTE1QzExMC4zOTggMTM5LjIzMSAxMTAuMjE4IDEzOC43MTggMTA5Ljg1NiAxMzguMzc2QzEwOS40OTQgMTM4LjAzNCAxMDguOTUyIDEzNy44NjQgMTA4LjMxOSAxMzcuODY0QzEwNi43ODIgMTM3Ljg2NCAxMDYuMDU5IDEzOC42MzMgMTA2LjA1OSAxNDAuMjU3VjE0Ni40OTZIMTAyLjQ0M1YxMzUuMDQzSDEwNi4wNTlWMTM2LjE1NEMxMDYuNzgyIDEzNS4yMTQgMTA3Ljk1OCAxMzQuNzg3IDEwOS40OTQgMTM0Ljc4N0MxMTAuNzYgMTM0Ljc4NyAxMTEuODQ1IDEzNS4yMTQgMTEyLjc0OSAxMzYuMDY5QzExMy42NTMgMTM2LjkyMyAxMTQuMDE0IDEzOC4wMzQgMTE0LjAxNCAxMzkuNTczVjEzOS40MDJaIiBmaWxsPSIjOTY1RTFBIi8+CjxwYXRoIGQ9Ik0xMTYuNDU1IDE0Ni40MVYxMjkuNzQ0SDEyMC4wNzFWMTQ2LjQxSDExNi40NTVaIiBmaWxsPSIjOTY1RTFBIi8+CjxwYXRoIGQ9Ik0xMzAuMzc3IDEzNC45NThIMTM0LjI2NEwxMzAuMTA2IDE0Ni4wNjlDMTI5LjQ3MyAxNDcuODY0IDEyOC41NjkgMTQ5LjE0NiAxMjcuMzk0IDE0OS45MTVDMTI2LjMwOSAxNTAuNjg0IDEyNC44NjIgMTUxLjAyNiAxMjMuMTQ1IDE1MC45NFYxNDcuNzc4QzEyMy45NTggMTQ3Ljc3OCAxMjQuNTkxIDE0Ny42MDcgMTI1LjA0MyAxNDcuMzUxQzEyNS40OTUgMTQ3LjA5NCAxMjUuODU3IDE0Ni41ODEgMTI2LjEyOCAxNDUuODk4TDEyMS4zMzcgMTM0Ljk1OEgxMjUuMzE0TDEyOC4wMjYgMTQxLjk2NkwxMzAuMjg2IDEzNC45NThIMTMwLjM3N1oiIGZpbGw9IiM5NjVFMUEiLz4KPC9zdmc+Cg==");
;// CONCATENATED MODULE: ./assets/sgc_img_18+.svg
/* harmony default export */ var sgc_img_18_ = ("https://shopfront-cdn.tekoapis.com/_next/static/images/sgc_img_18+-20719fc2d35a93e724582b34140f32a0.svg");
;// CONCATENATED MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const useHandlerUnderEighteenYearOld = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isBot , tenant  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { user , loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const { handleUnder18  } = props;
    const isSGC = tenant === "sgc";
    // EPIC-315: effect replace images when user is under 18 years old
    const convertProduct = (0,react.useCallback)((product)=>{
        var ref;
        const { addToCart  } = product;
        const emptyImages = (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.map((image)=>_objectSpreadProps(_objectSpread({}, image), {
                src: ""
            }))) || [];
        // if bot or product doesn't has adult category, no need to check age
        if (!flags.epic_ecom_315 || isBot || !(0,confirm18YearsOld/* isAdultCategoryProduct */.C2)(product.categories)) return {
            images: (product === null || product === void 0 ? void 0 : product.images) || [],
            imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || "",
            actionReady: true,
            addToCart
        };
        // if isn't serverless, no need to check age
        if (!(0,helpers/* isServerless */.ep)() || authLoading) {
            return {
                images: emptyImages,
                imageUrl: "",
                actionReady: false
            };
        } else {
            const requireCheckAge = (0,confirm18YearsOld/* requiredConfirm18YearsOld */.bO)(user);
            if (!requireCheckAge) {
                return {
                    images: (product === null || product === void 0 ? void 0 : product.images) || [],
                    imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || "",
                    actionReady: true,
                    addToCart
                };
            } else {
                var ref1;
                handleUnder18 === null || handleUnder18 === void 0 ? void 0 : handleUnder18();
                return {
                    images: (product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1.map((image)=>_objectSpreadProps(_objectSpread({}, image), {
                            src: isSGC ? sgc_img_18_ : _18_
                        }))) || [],
                    imageUrl: isSGC ? sgc_img_18_ : _18_,
                    actionReady: false
                };
            }
        }
    }, [
        user,
        authLoading,
        isBot
    ]);
    const transformProductWhenUserUnder18 = (0,react.useCallback)((product)=>{
        // if bot or product doesn't has adult category, no need to check age
        if (!flags.epic_ecom_315 || isBot || !product.isAlcoholicCategory) return _objectSpread({}, product);
        // if isn't serverless, no need to check age
        if (!(0,helpers/* isServerless */.ep)() || authLoading) {
            return _objectSpreadProps(_objectSpread({}, product), {
                imageUrl: "",
                // Hidden all button in this case
                addToCart: undefined,
                ctaButton: undefined,
                contactButton: undefined
            });
        } else {
            const requireCheckAge = (0,confirm18YearsOld/* requiredConfirm18YearsOld */.bO)(user);
            if (!requireCheckAge) {
                return _objectSpread({}, product);
            } else {
                handleUnder18 === null || handleUnder18 === void 0 ? void 0 : handleUnder18();
                return _objectSpreadProps(_objectSpread({}, product), {
                    imageUrl: isSGC ? sgc_img_18_ : _18_,
                    // Hidden all button in this case
                    addToCart: undefined,
                    ctaButton: undefined,
                    contactButton: undefined
                });
            }
        }
    }, [
        user,
        authLoading,
        isBot
    ]);
    return {
        convertProduct,
        transformProductWhenUserUnder18
    };
};


/***/ })

}]);